import {useCallback, useState} from "react";
import {multiLanguageValue} from "../../../../Components/JsonScreen/Utils/lib";
import {useDispatch, useSelector} from "react-redux";
import {handleFormValidators} from "../../../../Components/JsonScreen/jsonScreen.slice";

function useValidateField() {
    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const dispatch = useDispatch();
    const userLanguage = useSelector(state => state.app.userLanguage);

    const validate = useCallback((value, pattern, patternTitle, externalError) => {
        if(externalError) {
            setIsValid(false)
            return
        }
        const isValid = fieldValidator(value, pattern)
        if (!isValid) {
            setErrorMessage(multiLanguageValue(patternTitle, userLanguage) || 'Please match the requested format ' + pattern)
            setIsValid(isValid)
            dispatch(handleFormValidators({isValid}))
            return
        }
        setErrorMessage('')
        setIsValid(isValid)
        dispatch(handleFormValidators({isValid}))
    }, [])

    return {
        validate,
        isValid,
        errorMessage
    }
}

function fieldValidator(value, pattern) {
    if (!value || !pattern) return true;
    const regex = new RegExp(pattern);
    return regex.test(value);
}

export {useValidateField}

